import { Button, Classes, Dialog } from "./externals";
import React from "react";
export class ElementWithDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.openDialog = () => {
            this.setState({
                isDialogOpen: true,
            });
        };
        this.closeDialog = () => {
            this.setState({
                isDialogOpen: false,
            });
        };
        this.state = {
            isDialogOpen: false,
        };
    }
    render() {
        const { element, dialog, title } = this.props;
        const { isDialogOpen } = this.state;
        return (React.createElement(React.Fragment, null,
            element(this.openDialog),
            React.createElement(Dialog, { icon: "projects", title: title, style: { width: "80%" }, isOpen: isDialogOpen, usePortal: process.env.NODE_ENV !== "test", onClose: this.closeDialog },
                React.createElement("div", { className: Classes.DIALOG_BODY }, dialog),
                React.createElement("div", { className: Classes.DIALOG_FOOTER },
                    React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                        React.createElement(Button, { onClick: this.closeDialog }, "close"))))));
    }
}
//# sourceMappingURL=ElementWithDialog.js.map